module.exports = __webpack_public_path__ + "img/14.cd379951.png";